define( [
	"../core",
	"../selector",
	"../effects"
], function( jQuery ) {

"use strict";

jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/effects/animatedSelector.js
// module id = 966
// module chunks = 243